const Contact = ({ children }) => {
  const base =
    'flex flex-col items-center lg:items-start gap-y-smallMobile lg:gap-y-smallDesktop mt-mediumMobile lg:mt-0'

  return <div className={base}>{children}</div>
}

export default Contact
